<template>
    <div>
        <a-spin :spinning="spinning">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    :colon="false"
            >
                <a-form-model-item ref="inactive_days" label="不活跃天数" prop="inactive_days"
                                   :help="formErr.inactive_days"
                                   :validateStatus='!formErr.inactive_days||formErr.inactive_days ==""?"":"error"'>
                    <a-input v-model="form.inactive_days"
                             @change="(e) => { formErr.inactive_days='' }"
                          />
                </a-form-model-item>

              <a-form-model-item label="黑名单" prop="a_customer_ids" ref="a_customer_ids"   :help="formErr.a_customer_ids"
                                 :validateStatus='!formErr.a_customer_ids||formErr.a_customer_ids ==""?"":"error"'>
                <a-select v-model="form.a_customer_ids" mode="multiple" @change="(e) => { formErr.a_customer_ids='' }">
                  <a-select-option :value="item.id"  v-for="(item, index) in customerList" :key="index">
                  {{item.name}}
                  </a-select-option>

                </a-select>
              </a-form-model-item>
                <a-form-model-item ref="send_time" label="发送时间" prop="send_time"
                                   :help="formErr.send_time"
                                   :validateStatus='!formErr.send_time||formErr.send_time==""?"":"error"'>
                  <a-time-picker  v-model="form.send_time"  format="HH:mm"  valueFormat="HH:mm"  @change="(e) => { formErr.send_time='' }"/>

                </a-form-model-item>

                <a-form-model-item ref="content" label="发送内容" prop="content" :help="formErr.content"
                                   :validateStatus='!formErr.content||formErr.content==""?"":"error"'>
                    <a-textarea :showCount="true" :maxLength="70" :rows="4" v-model="form.content" @change="(e) => { formErr.content='' }" />
                  <p style="text-align: right;line-height: 1">{{form.content.length}}/70</p>
                </a-form-model-item>
                <a-form-model-item label=" ">
                    <a-button type="primary" @click="onSubmit">
                        确认
                    </a-button>
                    <!--                    <a-button style="margin-left: 10px;" @click="resetForm">-->
                    <!--                        -->
                    <!--                    </a-button>-->
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </div>
</template>

<script>

    import API from "./api"
    import {submitForm, validator,checkUrl} from "../../../utils/utils"
    import moment from 'moment';
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    export default {
        name: "index",
        data() {
            let checkUrls=checkUrl
            return {
              customerList: [],
                spinning: true,
                formErr: {
                  inactive_days: "",
                  send_time: "",
                  content: "",
                  a_customer_ids: "",
                },
                labelCol: {span: 4},
                wrapperCol: {span: 10},
                other: '',
                form: {
                  inactive_days: "",
                  send_time: null,
                  content: "",
                  a_customer_ids: [],
                },

                rules: {
                  content: [
                    { required: true, message: '请输入发送内容', trigger: 'blur' },

                    {
                        validator: (rule, value, callback) => {
                            validator(rule, value, callback, this.formErr.content)
                        }, trigger: "blur"
                    },],
                  inactive_days: [{ required: true, message: '请输入不活跃天数', trigger: 'blur' }, { pattern: /^[1-9][0-9]*$/, message: "请输入正整数" },{
                    validator: (rule, value, callback) => {
                      validator(rule, value, callback, this.formErr.inactive_days)
                    }, trigger: "blur"
                  },],
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/InformationSettings"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getFormData()
        },
        methods: {moment,
            changeSupportUrl(){
                this.$refs.ruleForm.clearValidate('technical_support_url', (contentError) => {  })
            },
            getFormData() {
                API.informationSettings.GET_DATA().then(res => {
                  this.customerList= res.data.data.customerList
                    let data = res.data.data.info
                  if(data.a_customer_ids!=''&&data.a_customer_ids.includes(',')){
                    data.a_customer_ids=data.a_customer_ids.split(',').map(Number);
                  }
                  else if(data.a_customer_ids!=''&&!data.a_customer_ids.includes(',')){
                    data.a_customer_ids=[data.a_customer_ids*1]
                  }else{
                    data.a_customer_ids=[]
                  }
                   this.form = data
                    this.spinning = false;
                })

            },

            onSubmit() {
                let _this = this;
                let formVal = JSON.parse(JSON.stringify(this.form))
              formVal.a_customer_ids=formVal.a_customer_ids.toString()
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.informationSettings.SUBMIT_ADD, {...formVal}).then(res => {
                            if (res == true) {
                                this.form = {
                                  inactive_days: "",
                                  send_time: null,
                                  content: "",
                                  a_customer_ids: [],
                                },
                                    this.getFormData()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .lab {
        position: absolute;
        top: 8px;
        width: 100%;
        left: 0
    }
</style>
